import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, Validators, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {ContactService, ProductService, TypesService} from '../../../services';
import {Subject} from 'rxjs';
import {DataHandlerService} from '../../../services/data-handler.service';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import _ from 'lodash';
import { AddressSuggestionsComponent } from '../address-suggestions/address-suggestions.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { NgFor, NgIf, NgClass, UpperCasePipe } from '@angular/common';
import {
  SensisMobileComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/sensis-mobile/sensis-mobile.component';
import {
  SensisEmailComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/sensis-email/sensis-email.component';
import {
  AddressSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/address-search/address-search.component';
@Component({
    selector: 'app-company-details',
    templateUrl: 'company-details.component.html',
    standalone: true,
    imports: [NgFor, MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, NgIf, MatFormFieldModule,
      MatFormFieldModule, MatInputModule, MatInputModule, ValidationPartialComponent, MatSelectModule, MatSelectModule,
      MatOptionModule, MatOptionModule, NgClass, MatCheckboxModule, MatCheckboxModule, forwardRef(() => AddressSuggestionsComponent), UpperCasePipe,
    SensisMobileComponent, SensisEmailComponent, AddressSearchComponent]
})

export class CompanyDetailsComponent extends WizardWidgetComponent implements OnInit, OnDestroy {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public selectedAbnResults: any;
  @Input() public personList: any;
  @Input() public trustCompanyContactList: any;
  @Input() public trustList: any;
  @Input() public borrowerType: any;
  public companyFormArray: UntypedFormArray;
  public isSmsf = false;
  public setContactValidatorsValue: Boolean;
  public industryTypes = [];
  public companyList = [];
  private industryTypesSlug = 'industry-type';
  public contactList = [];
  public selectedContacts = [];
  private unsubscribe$ = new Subject();
  public subscriptions = [];
  public currentFormGroupState: any = [];
  private readonly contactType = 'company';

  constructor(
    private typesService: TypesService,
    public dataHandleService: DataHandlerService,
    public productService: ProductService,
    public readonly contactService: ContactService
  ) {
    super(dataHandleService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.companyFormArray = this.formGroup.get('companyList') as UntypedFormArray;
    this.currentFormGroupState = this.companyFormArray.value;
    this.checkAddresses(this.companyFormArray.value);
    if (sessionStorage.getItem(this.industryTypesSlug)) {
      this.industryTypes = JSON.parse(sessionStorage.getItem(this.industryTypesSlug));
    } else {
      // get a list of the condition entity types
      this.typesService.getTypesList(this.industryTypesSlug)
        .then(
          entities => {
            this.industryTypes = entities;
          },
          error => {
            console.log(error);
          }
        );
    }

    this.productService.getProductParameters()
      .subscribe((result: any) => {
        if (result && result.isSMSF || result && result.isSMSF === false) {
          this.isSmsf = result.isSMSF;
          this.checkSmsfFormValidation();
        }
      });

    this.dataHandleService.getBorrowerTypeData().subscribe((result: any) => {
      this.borrowerType = result;
      this.checkContactList();
    });

    this.contactService.selectedContactsListener
      .pipe(debounceTime(750))
      .subscribe((result: any) => {
        this.selectedContacts = (result) ? result : [];
        this.checkContactList();
      });

    this.subscriptions.push(this.companyFormArray.valueChanges
      .pipe(debounceTime(750))
      .subscribe((companies: any[]) => {
        companies.forEach((payload, index) => {
          const currentCompany = this.currentFormGroupState[index];
          if (!(_.isEqual(currentCompany, payload))) {
            if (!currentCompany || !(_.isEqual(currentCompany.tradingAddress, payload.tradingAddress))) {
              this.duplicateAddresses(payload, index);
            }
            this.saveContactList(payload, index);
            this.currentFormGroupState[index] = payload;
          }
        });
      })
    );
    this.contactService.contactListListener
      .pipe(debounceTime(750)).subscribe((payload) => {
      this.contactList = payload;
      this.checkContactDetails();
    });
    this.createContactList();
    this.checkContactDetails();
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  createContactList() {
    this.companyFormArray.controls.forEach((fg: UntypedFormGroup, index: number) => {
      this.saveContactList(fg.value, index);
    });
    this.checkContactList();
  }

  /**
   * save to contact list
   * @param dataInput
   * @param index
   */
  public async saveContactList (dataInput, index: number) {
    this.contactService.save({
      index,
      type: this.contactType,
      companyTrustName: (dataInput.companyName) ? dataInput.companyName : 'Company ' + (index + 1),
      contactName: dataInput.companyContactName,
      contactPosition: dataInput.companyContactPosition,
      contactMobile: dataInput.companyContactMobile,
      contactEmail: dataInput.companyContactEmail,
      isDisabled: false
    });
  }

  checkContactDetails() {
    this.contactService.checkContactDetails(this.companyFormArray, this.contactType);
  }

  checkContactList() {
    this.contactService.addContactFieldsIfNotExists(this.companyFormArray, this.contactType);
  }

  setContact(event, formGroup, contact, i) {
    if (event.checked) {
      this.contactService.updateContactControlEnableStatus(formGroup, false, this.contactType);
      formGroup.get('contactSelected').patchValue(contact.identity);
      this.contactService.addToSelectedContacts(contact.identity);

      this.setContactValidators(formGroup, true, contact);
    } else {
      const contactToUpdate = this.contactService.getContact(this.contactService.getContactIdentity(this.contactType, i));
      if (contactToUpdate) {
        contactToUpdate.contactName = '';
      }

      this.setContactValidators(formGroup, false);
      this.contactService.updateContactControlEnableStatus(formGroup, true, this.contactType);
      formGroup.get('contactSelected').patchValue(null);
      this.contactService.removeToSelectedContacts(contact.identity);
      this.checkContactList();
    }
  }

  checkSmsfFormValidation() {
    if (this.isSmsf) {
      const securityTrustId = 1;
      const foundFormIndex = this.companyFormArray.value.findIndex(x => x.trusteeOf === securityTrustId);

      if (foundFormIndex >= 0) {
        this.companyFormArray.at(foundFormIndex).get('companyACN').clearValidators();
        this.companyFormArray.at(foundFormIndex).get('companyACN').updateValueAndValidity({emitEvent: false});
      }
    }
  }

  // Fetch entities with contact details that can be used for "Same As" functionality
  getPopulatedEntities(data, type) {
    console.log('entities', data, type);
    const entities = [];
    if (data) {
      data.forEach((element, index) => {
        element.id = index;
        if (element[`${type}ContactName`] &&
          element[`${type}ContactPosition`] &&
          element[`${type}ContactMobile`] &&
          element[`${type}ContactEmail`]) {
          entities.push({...element, type});
        }
      });
    }


    return entities;
  }

  checkAddresses(data) {
    // console.log('[checkAddresses]', data);
    for (let i = 0; i < data.length; i++) {
      this.duplicateAddresses(data[i], i);
    }
  }

  duplicateAddresses (data, index: number) {
    this.addressAsAbove(index, 'postalAddress', data);
    this.addressAsAbove(index, 'postSettlementAddress', data);
  }

  addressAsAbove(index, formControlName, data) {
    const fg = this.companyFormArray.at(index);
    if (data && data[`${formControlName}AsTrading`] === true && fg) {
      fg.patchValue({[formControlName]: data['tradingAddress']}, {emitEvent: false});
      if (fg.get('tradingAddress').touched) {
        fg.get(formControlName).updateValueAndValidity();
        fg.get(formControlName).markAsTouched();
      }
    }
  }

  setContactValidators(control, set: Boolean, data?: any) {
    this.setContactValidatorsValue = set;
    this.contactService.setContactValidators(control, set, data, this.contactType);
  }
}
